import React, { ComponentType } from 'react'
import { Segment } from 'semantic-ui-react'
// Local
import { formatDob } from '../../common/formatUtils'
import { patientMrn } from '../../common/patientUtils'
import { FORMAT } from '../../../constant'
import { semiColonsToLineBreaks } from '../../v2/utils/utils'
import { Encounter } from '../../authenticated/types'
import If from '../../common/if'

const SafeSegment = Segment as unknown as ComponentType<any>

/**
 * Provides a component that renders the encounter patient information. The
 * default return is the patient MRN.
 *
 * Unfortunately we have not been consistent with our patient identifiers.
 * Ideally we would just always show the patient MRN property value but for
 * various reasons, many of which are lost to time, the tenants are inconsistent
 * with how they store patient identifiers.
 *
 * @param encounter Encounter entity
 * @param mode Render mode. Default: left
 * @param displayName If true display the patient's name
 *        Default: false
 * @param displayBirthDate If true display the patient's date of birth
 *        Default: false
 */

type Props = {
  encounter: Encounter | undefined
  mode?: string | undefined
  displayName?: boolean | undefined
  displayBirthDate?: boolean | undefined
}

function EncounterPatient(
  props: Props
): JSX.Element | null {
  const {
    encounter,
    mode = 'left',
    displayName: isDisplayName = false,
    displayBirthDate: isDisplayBirthDate = false
  } = props

  if (mode === 'left') {
    const mrn = patientMrn(encounter && encounter.patient)
    return (
      <SafeSegment
        attached
        compact
        className="left-segment"
      >
        <If isTrue={ isDisplayName }>
          <div>
            <div className="left-title">
              Patient Name:
            </div>
            <div className="left-content">
              { encounter && encounter.patient && encounter.patient.firstName }
              &nbsp;
              { encounter && encounter.patient && encounter.patient.lastName }
            </div>
          </div>
        </If>
        <div className="left-title">
          Patient MRN(s):
        </div>
        <div className="left-content mrn">
          { semiColonsToLineBreaks(mrn || '') }
        </div>
        <If isTrue={ isDisplayBirthDate }>
          <div>
            <div className="left-title">
              Date of Birth:
            </div>
            <div className="left-content">
              {
                formatDob(
                  encounter && encounter.patient && encounter.patient.birthDate,
                  FORMAT.DATE
                )
              }
            </div>
          </div>
        </If>
      </SafeSegment>
    )
  }
  return null
}

export default EncounterPatient
